import { Component, Inject, Input, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Card } from './card/card';

declare var moment: any;
@Component({
    selector: 'app-material-clock',
    templateUrl: './materialClock.ng2.html'
})

export class MaterialClockComponent implements OnInit {
    @Input() Card: Card;
    days = [];
    state = false;
    tab = 'time';
    display = null;

    meridian = null;
    model = null;

    config = {
        modal: true,
        color: 'rgba(255,255,255,0.75)',
        backgroundColor: 'rgba(0,0,0,0.75)'
    };

    constructor() {

    }

    generateTime() {
        let time = '';
        time += this.Card.Hour + ':';
        if (this.Card.Minute < 10) {
            time += '0' + this.Card.Minute;
        } else {
            time += this.Card.Minute;
        }

        return time;
    }


    setHour = function (hour) {
        if (!this.Card.Minute) { this.Card.Minute = 0 }
        if (!this.Card.TimeMode) { this.Card.TimeMode = 'AM' }

        this.Card.Hour = hour;

    }


    setMinutes = function (minute) {

        this.Card.Minute = minute;

    }



    ngOnInit() {
    }


}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/materialClock.ng2.ts